import {FC, PropsWithChildren, useState} from 'react';
import {NavigationContext} from './NavigationContext';

export const NavigationProvider: FC<PropsWithChildren> = ({children}) => {
  const [showChatbot, setShowChatbot] = useState(false);
  const [hideIcon, setHideIcon] = useState(false);

  return (
    <NavigationContext.Provider value={{showChatbot, setShowChatbot, hideIcon, setHideIcon}}>
      {children}
    </NavigationContext.Provider>
  );
};
